import PropTypes from 'prop-types';

import Input from 'common/components/form/styled-inputs/Input';

const regex = new RegExp('^[a-zA-Z0-9]*$');

const ColorInput = ({ onChange, ...rest }) => {
  const handleOnChange = event => {
    const inputValue = event?.target?.value;

    if (regex.test(inputValue) || inputValue === '') {
      onChange(event);
    }
  };

  return <Input onChange={handleOnChange} placeholder="Add 6-digit-code" maxLength={6} {...rest} />;
};

export default ColorInput;

ColorInput.propTypes = {
  onChange: PropTypes.func
};
